/**
 * @desc 根据来源单号获取对应的系统订单数据
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderBySpOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
